import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardGroup,
  CCardHeader,
  CCol,
  CContainer,
  CForm,
  CImg,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import AlertNotify from "../helper/AlertNotify";
import { useTranslation } from 'react-i18next';
import LanguageSelector from "../helper/LanguageSelector";

function OrderPageLogin(props) {
  const history = useHistory();
  const [orderCode, setOrderCode] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const { t } = useTranslation();

  function onInputChange(event){
      setOrderCode(event.target.value);
  }

  function GoOrderPage() {
    history.push("/orderPage/"+orderCode);
  }

  if(history.location.state?.wrongCode){
    setErrorMessage(t("orderPageLogin.errorInvalidCode"));
    setShowMessage(true);
    history.location.state.wrongCode = false;
  }
  else if(history.location.state?.wrongRobot){
    setErrorMessage("Wrong robot for given order code!");
    setShowMessage(true);
    history.location.state.wrongCode = false;
  }

  return (
    <>
    <div className="text-right">
      <LanguageSelector className="mr-3" />
      </div>
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="5">
              <CCard className="p-2 px-4">
                <CCardHeader className="text-center">
                  <h1>{t("orderPageLogin.title")}</h1>
                </CCardHeader>
                <CCardBody>
                  <CForm>
                    <div className="text-center">
                      <CImg src="./img/derlivers_hepsiBurada.png" width="60%" />
                    </div>
                    <p className="text-muted">{t("orderPageLogin.info")}</p>
                    <CInputGroup className="mb-3"><CInputGroupPrepend><CInputGroupText><CIcon name="cilFastfood" /></CInputGroupText></CInputGroupPrepend>
                      <CInput onChange={onInputChange}  name="orderCode" placeholder={t("orderPageLogin.placeholder")} />
                    </CInputGroup>
                    <CRow>
                      <CCol xs="8">
                        <CButton color="link" className="px-0">{t("orderPageLogin.help")}</CButton>
                      </CCol>
                      <CCol xs="4" className="text-right">
                        <CButton onClick={GoOrderPage} color="primary" className="px-4">{t("orderPageLogin.button")}</CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>

                <CCardFooter>
                  <AlertNotify message={errorMessage} show={showMessage} onClose={()=>setShowMessage(false)} ></AlertNotify>
                </CCardFooter>
                
              </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    </>
  )
}

export default OrderPageLogin